import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { MasterService } from "src/app/services/master.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { FeatureResponseModel } from "src/app/model/FeatureResponseModel";

@Component({
  selector: "app-secure-feature-au",
  templateUrl: "./feature-au.component.html",
  styleUrls: ["./feature-au.component.scss"],
})
export class FeatureAUComponent implements OnInit {
  featureKey: number;
  pageMode: string;
  featureModel : FeatureResponseModel;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  parentFeatureList: {[key: number]: string};

  constructor(
    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.masterService
    .initFeatureForm()
    .subscribe((data: any) => {
      if(data.status === 'SUCCESS') {
        this.parentFeatureList = data.parentFeatureList;
      }
      else {
        this.errorToast(data.errorMessage, 5*1000);
      }
      this.route.params.subscribe((params: Params) => {
        this.featureKey = +params["key"];      
        if(this.featureKey) {
          this.masterService
            .getFeatureBykey(this.featureKey)
            .subscribe((data: any) => {
              this.featureModel = data;
              this.pageMode = "Edit";
              this.form.patchValue({
                featureLabel: this.featureModel.featureLabel,
                featureIcon: this.featureModel.featureIcon,
                frontEndUrl: this.featureModel.frontEndUrl,
                backEndCode: this.featureModel.backEndCode,
                hasUrl: this.featureModel.frontEndUrl !== null ? true : false,
                parentFeatureKey: this.featureModel.parentFeatureKey,
                displayOrder: this.featureModel.displayOrder
              });
            });
        }
        else {
          this.pageMode = "Add";
        }
      });
    });
    this.form = new FormGroup({
      featureLabel: new FormControl(null, Validators.required),
      featureIcon: new FormControl(null),
      frontEndUrl: new FormControl(null),
      backEndCode: new FormControl(null),
      hasUrl: new FormControl(null),
      parentFeatureKey: new FormControl(null),
      displayOrder: new FormControl(null),
    });
  }

  onSubmit() {
    if(this.pageMode === 'Add') {
      this.save();
    }
    else {
      this.update();
    }
  }

  async save() {
    if (this.form.valid) {
      this.masterService
      .saveFeature({
        featureLabel: this.form.value.featureLabel,
        featureIcon: this.form.value.featureIcon,
        frontEndUrl: this.form.value.frontEndUrl,
        backEndCode: this.form.value.backEndCode,
        hasUrl: this.form.value.hasUrl ? 'Y' : 'N',
        parentFeatureKey: this.form.value.parentFeatureKey?.key,
        displayOrder: this.form.value.displayOrder,
      })
      .subscribe((data: any) => {
          if(data.status === 'SUCCESS') {
            this.successToast();
            this.router.navigate(["/secure", "master", "feature", "list"]);
          }
          else {
            this.isSubmitDisabled = false;
            this.errorToast(data.errorMessage);
          }
        }, error => {
          this.isSubmitDisabled = false;
          console.log(error);
          this.errorToast(error.error.errorMessage, 5*1000);
        });
    } else {
      this.isSubmitDisabled = false;
      this.errorToast("");
    }
  }

  async update() {
    if (this.form.valid) {
      this.masterService
      .updateFeature(this.featureKey, {
        featureLabel: this.form.value.featureLabel,
        featureIcon: this.form.value.featureIcon,
        frontEndUrl: this.form.value.frontEndUrl,
        backEndCode: this.form.value.backEndCode,
        hasUrl: this.form.value.hasUrl ? 'Y' : 'N',
        parentFeatureKey: this.form.value.parentFeatureKey?.key,
        displayOrder: this.form.value.displayOrder,
      }).subscribe((data: any) => {
        if(data.status === 'SUCCESS') {
          this.successToast();
          this.router.navigate(["/secure", "master", "feature", "list"]);
        }
        else {
          this.isSubmitDisabled = false;
          this.errorToast(data.errorMessage);
        }
      }, error => {
        this.isSubmitDisabled = false;
        console.log(error);
        this.errorToast(error.error.errorMessage, 5*1000);
      });
    } else {
      this.isSubmitDisabled = false;
      this.errorToast("");
    }
  }

  async successToast() {
    await this._snackBar.open(
      "Feature details saved successfully.",
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }

  showParentFeature(o1: any, o2: any) {
    if(o1 && o2 && o1.key == o2) {
      return o1.value;
    }
    else {
      return "";
    }
  }
}